<script>
import PaginatedResourceTable from '@shell/components/PaginatedResourceTable';
import { fetchNodesForServiceTargets } from '@shell/models/service';

export default {
  name:       'ListService',
  components: { PaginatedResourceTable },
  props:      {
    resource: {
      type:     String,
      required: true,
    },

    schema: {
      type:     Object,
      required: true,
    },

    useQueryParamsForSimpleFiltering: {
      type:    Boolean,
      default: false
    }
  },

  methods: {
    /**
     * of type PagTableFetchSecondaryResources
     */
    async fetchSecondaryResources(opts) {
      // Nodes should be fetched because they may be referenced in the target column of a service list item.
      await fetchNodesForServiceTargets({
        $store:  this.$store,
        inStore: this.$store.getters['currentStore']()
      });
    }
  }
};
</script>

<template>
  <PaginatedResourceTable
    class="service-resource-table"
    :schema="schema"
    :use-query-params-for-simple-filtering="useQueryParamsForSimpleFiltering"
    :fetchSecondaryResources="fetchSecondaryResources"
  />
</template>

<style lang="scss" scoped>
.service-resource-table {
  :deep(.col-link-detail) { min-width: 240px; overflow-wrap: normal; word-break: normal; }
  :deep(.col-link-name) { min-width: 150px; overflow-wrap: normal; word-break: normal; }
  :deep(.col-service-targets) { min-width: 210px; }
  :deep(.col-key-value) { min-width: 230px; }
}
</style>
